// extracted by mini-css-extract-plugin
export default {"card":"AY-z","carouselContainer":"BY-z","carouselContent":"CY-z"};